import  basicEnums from "./basicEnum";
import  doctorEnums  from "./doctorEnum";

export class EnumUtils {
    static enumMap = new Map();
    static inited = false; 

    static getEnumDisplay = function(type, value){
        if(!EnumUtils.inited) {
            EnumUtils.init();
            EnumUtils.inited = true;
        }
        const map = EnumUtils.enumMap.get(type);
        // return `${map.get(value)}-(${value})`;
        return map.get(value);
    }
    static setEnum = function(type,value) {
        EnumUtils.enumMap.set(type,value);
    }

    static init = function(){
        for(var key in doctorEnums){  
            EnumUtils.setEnum(key,  doctorEnums[key]);   
        }
        for(var key in basicEnums){  
            EnumUtils.setEnum(key,  basicEnums[key]);   
        }
    }
}